module.exports = __webpack_public_path__ + "img/video_menu_mike_off.6b98558d.svg";